import React from 'react';
import './ButtonSpinner.css';

interface ButtonSpinnerProps {
  size?: number;
  color?: string;
}

const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({ size = 16, color = 'currentColor' }) => {
  return (
    <svg
      className="button-spinner"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
    >
      <circle cx="12" cy="12" r="10" opacity="0.25" />
      <path d="M12 2a10 10 0 0 1 10 10" />
    </svg>
  );
};

export default ButtonSpinner;
